import { tabModelKey } from '../settings';

const fraudTabs = [
  'linkedAccount',
  'multiAccount',
  'monitoring',
  'gameStyle',
  'behavioralAnomaly',
  'arbitrage'
];

const data = (key, models) => {
  if (!models) {
    return null;
  }

  // Fraud-style endpoints return Models as the alerts array directly
  if (fraudTabs.includes(key) || !tabModelKey[key]) {
    return models;
  }

  return models[0]?.[tabModelKey[key]] ?? null;
};

const parseAlertMonitorModelFromGetResponse = (response: Object, tabKey: string) => {
  const responseData = response?.Data || {};
  const { Models, TotalCount } = responseData;

  return {
    data: data(tabKey, Models),
    totalCount: TotalCount
  };
};

export default parseAlertMonitorModelFromGetResponse;
